import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IncompleteDataDetail } from '../models/incomplete-data';

export interface ModalData {
  title: string;
  dates: string[];
  detailData: IncompleteDataDetail[];
  businessLineId: number;
  isVisible: boolean;
  isDetailView: boolean; // Flag untuk membedakan tampilan detail atau biasa
}

@Injectable({
  providedIn: 'root'
})
export class ModalIncompleteService {

  private modalDataSubject = new BehaviorSubject<ModalData>({
    title: '',
    dates: [],
    detailData: [],
    businessLineId: 0,
    isVisible: false,
    isDetailView: false
  });

  public modalData$ = this.modalDataSubject.asObservable();

  // Method untuk tampilkan modal dengan data detail dari API
  showModalWithDetail(title: string, detailData: IncompleteDataDetail[], businessLineId: number) {
    this.modalDataSubject.next({
      title,
      dates: [],
      detailData,
      businessLineId,
      isVisible: true,
      isDetailView: true
    });
  }

  // Method lama untuk fallback
  showModal(title: string, incompleteData: string, businessLineId: number) {
    const dates = this.parseDates(incompleteData);
    this.modalDataSubject.next({
      title,
      dates,
      detailData: [],
      businessLineId,
      isVisible: true,
      isDetailView: false
    });
  }

  hideModal() {
    const currentData = this.modalDataSubject.value;
    if (currentData.isVisible) {
      this.modalDataSubject.next({
        ...currentData,
        isVisible: false
      });
    }
  }

  resetModal() {
    this.modalDataSubject.next({
      title: '',
      dates: [],
      detailData: [],
      businessLineId: 0,
      isVisible: false,
      isDetailView: false
    });
  }

  private parseDates(incompleteData: string): string[] {
    return incompleteData.split(', ').map(date => this.formatDate(date));
  }

  private formatDate(date: string): string {
    if (date.includes('-') && date.length === 10) {
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year.slice(-2)}`;
    }
    else if (date.includes('W')) {
      return date;
    }
    else if (date.length === 4) {
      return date;
    }
    return date;
  }
}
